<template>
<el-row type="flex" justify="center">
	<el-col :xs="24" :sm="12" :md="10" :lg="8">
		<el-form label-position="top" label-width="100px">
			<h1>Login</h1>
			<hr>
			<el-form-item label="Email:">
				<el-input placeholder="Your email address" type="email" v-model.trim="credentials.email" @input="$v.credentials.email.$touch()" :disabled="app.isLoading"></el-input>
				<span v-if="$v.credentials.email.$error">
				<span class="el-form-item__error" v-if="!$v.credentials.email.required">Field is required.</span>
				<span class="el-form-item__error" v-if="!$v.credentials.email.email">Must be a valid email.</span>
				</span>
			</el-form-item>
			<el-form-item label="Password:">
				<el-input placeholder="Your password" type="password" v-model.trim="credentials.password" @input="$v.credentials.password.$touch()" :disabled="app.isLoading"></el-input>
				<span v-if="$v.credentials.password.$error">
				<span class="el-form-item__error" v-if="!$v.credentials.password.required">Field is required.</span>
				</span>
			</el-form-item>
			<hr>
			<p>
				<el-button type="primary" @click="login()" :disabled="$v.$invalid" :loading="app.isLoading">Login</el-button>

				<small class="links">
					<router-link :to="{ name: 'Register' }">Register</router-link>
					<router-link :to="{ name: 'Reminder' }">Forgot your password?</router-link>
				</small>
			</p>
		</el-form>
	</el-col>
</el-row>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import router from "@/router";
import axios from "axios";
import { getToken, setUser, setToken, parseJWT } from "@/utils/auth";
import { LOGIN_URL } from "@/config";
import store from "@/utils/store";

export default {
	name: "login",
	data() {
		return {
			app: store,
			credentials: {
				email: "",
				password: ""
			}
		};
	},
	validations: {
		credentials: {
			email: {
				required,
				email
			},
			password: {
				required
			}
		}
	},
	methods: {
		login() {
			if (this.$v.$invalid) return;
			let _self = this;
			axios
				.post(LOGIN_URL, this.$data.credentials)
				.then(function(response) {
					setToken(response.data.token);
					setUser(response.data.user);
					return router.push("/dashboard");
				})
				.catch(function(error) {
					console.log(error.response);
					let res = error.response;
					return (_self.app.messages = [res.data.message]);
				});
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.links
	padding-left: 1em;
	a
		padding: 0 .5em;
</style>



// WEBPACK FOOTER //
// Login.vue?09d4050b